var $9e83f2ab3a156c72$exports = {};
$9e83f2ab3a156c72$exports = {
  "alert": "Teade",
  "dismiss": "L\xF5peta"
};
export { $9e83f2ab3a156c72$exports as default };